// import React, { useEffect } from "react";
// import "../assets/css/modal.css";
// import Loader from "./Loader";

// const Modal = ({
//   show,
//   onClose,
//   title,
//   children,
//   maxWidth = "900px",
//   clientStatus,
//   mainMenuStatus,
//   submenu1Status,
//   submenu2Status,
//   submenu3Status,
//   submenu4Status,
// }) => {
//   // 🔒 LOCK BACKGROUND SCROLL
//   useEffect(() => {
//     if (show) {
//       const scrollY = window.scrollY;

//       document.body.style.position = "fixed";
//       document.body.style.top = `-${scrollY}px`;
//       document.body.style.width = "100%";
//     } else {
//       const scrollY = document.body.style.top;

//       document.body.style.position = "";
//       document.body.style.top = "";
//       document.body.style.width = "";

//       if (scrollY) {
//         window.scrollTo(0, parseInt(scrollY) * -1);
//       }
//     }

//     return () => {
//       document.body.style.position = "";
//       document.body.style.top = "";
//       document.body.style.width = "";
//     };
//   }, [show]);

//   // ⌨ ESC KEY CLOSE
//   // Note: If you want to STOP the Escape key from closing it too, remove this useEffect block.
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", handleEsc);
//     return () => window.removeEventListener("keydown", handleEsc);
//   }, [onClose]);

//   if (!show) return null;

//   const isAnyLoading = [
//     clientStatus,
//     mainMenuStatus,
//     submenu1Status,
//     submenu2Status,
//     submenu3Status,
//     submenu4Status,
//   ].includes("loading");

//   return (
//     <div
//       className="modal-overlay"
//       /* onClick removed here to restrict closing on backdrop click */
//     >
//       {isAnyLoading && <Loader isLoading={true} />}

//       <div className="modal-box" style={{ maxWidth }}>
//         <div className="modal-header">
//           <h5 className="modal-title">{title}</h5>
//           <button className="btn-close" onClick={onClose} />
//         </div>

//         <div className="modal-body-content">{children}</div>
//       </div>
//     </div>
//   );
// };

// export default Modal;


import React, { useEffect } from "react";
import ReactDOM from "react-dom"; // Import ReactDOM
import "../assets/css/modal.css";
import Loader from "./Loader";

const Modal = ({
  show,
  onClose,
  title,
  children,
  maxWidth = "900px",
  /* Hides the ✕. For a dialog that asks a question about something ALREADY
     done: a close cross reads as "cancel this", and offering that when there
     is nothing left to cancel is a promise the dialog cannot keep. */
  hideClose = false,
  clientStatus,
  mainMenuStatus,
  submenu1Status,
  submenu2Status,
  submenu3Status,
  submenu4Status,
}) => {
  // 🔒 LOCK BACKGROUND SCROLL
  useEffect(() => {
    if (show) {
      const scrollY = window.scrollY;

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      const scrollY = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";

      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    }

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [show]);

  // ⌨ ESC KEY CLOSE
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!show) return null;

  const isAnyLoading = [
    clientStatus,
    mainMenuStatus,
    submenu1Status,
    submenu2Status,
    submenu3Status,
    submenu4Status,
  ].includes("loading");

  // --- THE FIX: Using createPortal ---
  // This moves the modal div outside your current component tree
  // and attaches it directly to the document body.
  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal-box" style={{ maxWidth }}>
        {/* Inside the box, not over the page.
         *
         * This was a bare <Loader /> sitting in the overlay — and a bare
         * Loader is a fixed, full-viewport skeleton (.container-loader). So a
         * dropdown still loading somewhere put a skeleton over the whole
         * application WITH THE DIALOG OPEN ON TOP OF IT, which is a state
         * nothing on screen can explain.
         *
         * A dialog waiting for its data should say so inside itself. */}
        {isAnyLoading && (
          <div className="modal-loading">
            <Loader isLoading inline variant="table" rows={4} cols={2} />
          </div>
        )}
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          {!hideClose && (
          <button 
             type="button" 
             className="btn-close" 
             onClick={onClose} 
             aria-label="Close"
          >
             {/* If you are using Bootstrap's btn-close, it has an SVG built-in. 
                 If not, you might need an 'X' or icon here like: <span>&times;</span> */}
          </button>
          )}
        </div>

        <div className="modal-body-content">{children}</div>
      </div>
    </div>,
    document.body // Target container
  );
};

export default Modal;